import * as yup from 'yup';

export const FosterCollaborationModalSchema = (t) =>
  yup.object({
    numParticipants: yup
      .number()
      .typeError(t('errors.forms.number'))
      .required(t('errors.forms.enterParticipantNumber')),
    language: yup.string().required(t('errors.forms.selectPreferredLanguage')),
    location: yup.string().required(t('errors.forms.enterWorkshopLocation')),
    date: yup.string().required(t('errors.forms.selectStartDate')),
    unit: yup.string().required(t('errors.forms.selectUnit')),
    comments: yup.string(),
  });

export const FosterCollaborationModalSchemaWithoutLocation = (t) =>
  yup.object({
    numParticipants: yup
      .number()
      .required(t('errors.forms.enterParticipantNumber')),
    language: yup.string().required(t('errors.forms.selectPreferredLanguage')),
    date: yup.string().required(t('errors.forms.selectStartDate')),
    unit: yup.string().required(t('errors.forms.selectUnit')),
    comments: yup.string(),
  });
